import {
    ControllerQueryConfig,
    UpdateResultGeneric,
    UpdateLoading,
    UpdateError,
    UpdateCompleted,
} from '../../types';
import useGenericSearchQuery from './useGenericSearchQuery';

const GenericSearchQuery = <T,>({
    queryConfig,
    queryString,
    page,
    itemsPerPage,
    updateResult,
    updateLoading,
    updateError,
    updateCompleted,
}: {
    queryConfig: ControllerQueryConfig;
    queryString: string;
    page: number;
    itemsPerPage: number;
    updateResult: UpdateResultGeneric<T>;
    updateLoading: UpdateLoading;
    updateError: UpdateError;
    updateCompleted: UpdateCompleted;
}) => {
    useGenericSearchQuery<T>({
        queryConfig,
        queryString,
        page,
        itemsPerPage,
        updateResult,
        updateLoading,
        updateError,
        updateCompleted,
    });

    return null;
};

export default GenericSearchQuery;
